
type Props = {
  collectionName: string
  collectionUrl: string
  fromMetaObject?: boolean
}

const SubCollectionFilter = ({collectionName, collectionUrl, fromMetaObject = false}: Props) => {
  const url = fromMetaObject ? collectionUrl : `/collections/${collectionUrl}`
  const cleanCollectionName = collectionName.includes(':') ? collectionName.split(':')[0] : collectionName
  const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash
  const domain = window.routes.domain 
  const urlWithLocale = !rootUrlWithoutSlash
    ? url
    : url.includes(rootUrlWithoutSlash)
    ? url
    : url.includes(domain)
    ? url.replace(domain, domain + rootUrlWithoutSlash)
    : rootUrlWithoutSlash + url

  return (
    <a href={urlWithLocale}  className={`uppercase cursor-pointer px-5 whitespace-nowrap`}>
      {cleanCollectionName}
    </a>
  )
}

export default SubCollectionFilter